import React from 'react';
import PropTypes from 'prop-types';
import IconInfo from './svg/IconInfo';

function TooltipInfo({ label }) {
  return (
    <div className={'tooltip-info'}>
      <IconInfo />
      <div className={'tooltip-info-content'}>{label}</div>
    </div>
  )
}

TooltipInfo.propTypes = {
  label: PropTypes.string.isRequired
}

export default TooltipInfo;
